import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </span>
              <span className="text-xl font-heading font-bold text-background-50">{siteInfo.name}</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed max-w-md">
              {siteInfo.description}
            </p>
            <div className="flex items-center gap-4 mt-4">
              <a href={siteInfo.social.weibo} target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-background-200"></i>
              </a>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-background-200"></i>
              </span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer">漫画分类</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line text-background-500"></i>
                <span>{siteInfo.email}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-phone-line text-background-500"></i>
                <span>{siteInfo.phone}</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-map-pin-line text-background-500 mt-0.5"></i>
                <span>{siteInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | 本站所有漫画内容均已获得正版授权
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <span className="cursor-pointer hover:text-background-300 transition-colors duration-200">隐私政策</span>
            <span className="cursor-pointer hover:text-background-300 transition-colors duration-200">用户协议</span>
            <span className="cursor-pointer hover:text-background-300 transition-colors duration-200">版权声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}